import { If } from '@finn/platform-modules';
import { CTA, Image } from '@finn/ui-components';
import { CTAData } from '@finn/ui-cosmic';
import { parseToHtml } from '@finn/ui-utils';

import CosmicModule from '../../CosmicModule';
import { Guide } from './Guide';

type NarrowContentProps = {
  title: string;
  subtitle?: string;
  src: string;
  cta?: CTAData;
  secondaryCta?: CTAData;
  guideMetaData: {
    reading_time?: string;
    date?: string;
  };
};

export const NarrowContent = ({
  title,
  subtitle,
  src,
  cta,
  secondaryCta,
  guideMetaData,
}: NarrowContentProps) => {
  return (
    <div className="container flex flex-col gap-8 pt-8 sm:w-[calc(100%-2rem)] md:w-[calc(100%-1rem)] md:max-w-[726px] md:pt-16">
      <h1 className="mobile-t3-semibold md:web-t3-semibold">
        {parseToHtml(title)}
      </h1>
      {subtitle && (
        <p className="raw-html-global body-16-light [&_ul]:m-0 [&_ul]:pl-4">
          {parseToHtml(subtitle)}
        </p>
      )}
      <If condition={Boolean(cta?.metadata || secondaryCta?.metadata)}>
        <div className="flex flex-col items-start gap-4 md:flex-row">
          {cta?.metadata && (
            <CTA CosmicModule={CosmicModule} data={cta.metadata} />
          )}
          {secondaryCta?.metadata && (
            <CTA
              variant="outline"
              CosmicModule={CosmicModule}
              data={secondaryCta.metadata}
            />
          )}
        </div>
      </If>
      <div className="flex flex-col gap-8">
        <Guide {...guideMetaData} />
        <Image
          alt={title}
          src={src}
          className="aspect-auto w-full md:-ml-20 md:w-[calc(100%+10rem)]"
        />
      </div>
    </div>
  );
};
